import {
  ArticleListResponse,
  AssignedArticleMotorListResponse
} from '@/modules/sales/clients/services/apiValidation/apiValidationSchemas.ts'
import {
  ArticleDetailDTO,
  AssignArticle,
  AssignArticleApple,
  EnrolledHoursResponse,
  MiscellaneousRentabilityDTO,
  MosyleDeviceLookupResponse
} from '@/modules/sales/clients/types/Article.ts'
import { QuoteListResponse } from '@/modules/sales/clients/components/articleTable/quoteTable/services/apiValidationSchemas.ts'
import { EditArticleRequestQuoteListResponse } from '@/modules/support/services/requestService/apiValidationSchemas.ts'
import { NuovoDevice } from '@/modules/sales/clients/types/ChangeCredit.ts'
import { Supplier } from '@/modules/sales/clients/types/Supplier'
import { EqualityDeviceInfoResponse } from '@/modules/sales/clients/services/apiValidation/equalityDeviceInfoApiValidation.ts'
import { QRImageDataApiValidationResponse } from '@/modules/sales/clients/services/apiValidation/qrImageDataApiValidation.ts'
import { RequireOTPResponse } from '@/modules/sales/clients/services/apiValidation/requireOTPApiValidation.ts'
import { InsuranceRentabilityOptionResponseSchema } from '@/core/services/selectServices.ts'
import { CreditUnpayResponse } from '@/modules/sales/clients/services/apiValidation/creditUnpayApiValidation.ts'
import { RentabilityResponse } from '@/modules/settings/tasa/types/types.ts'
import { MundoDeviceResponse } from '@/modules/sales/clients/services/apiValidation/mundoDeviceApiValidation.ts'
import { OriginCertificateResponse } from '@/modules/sales/clients/services/apiValidation/originCertificateApiValidation.ts'
import { CreditPreassignedDetailDTO } from '@/modules/sales/clients/types/CreditPreassigned.ts'
import { refinanceScenarioCredits } from '@/__mocks__/modules/articles/refinanceScenarios.ts'

export const articlesPage1: { data: ArticleListResponse; message: string } = {
  message: 'Cr\u00e9ditos obtenidos correctamente.',
  data: {
    results: [
      {
        creditId: '1',
        brandName: 'Suzuki',
        modelId: '2197',
        modelName: 'GN125',
        registerNumber: 'FDA028',
        branchOfficeName: 'Weppa',
        cost: '1000.00',
        discountedCredit: '1000.00',
        additionalCost: '700.00',
        initial: '120.00',
        initialTotal: '870.00',
        totalPayment: '184.00',
        createByName: 'Yosvani Nasco',
        extraPayment: '50.00',
        paymentByQuotes: '130.00',
        clientId: '131',
        categoryId: null,
        hasPendingSupportRequest: false,
        rentabilityId: '4',
        createdAt: '06/04/2026',
        productTypeId: '6',
        productTypeName: 'Motor',
        reinstallPending: false,
        isFraud: false,
        hasLateQuote: false,
        supplierCode: 'AUT',
        isFromNuovoToEquality: true,
        statusCredit: 'Paid',
        unpayCredit: false,
        isCollectionAgency: false,
        collectionAgencyName: null,
        weppaPlus: true
      },
      {
        creditId: '426446',
        brandName: 'Suzuki',
        modelId: '2197',
        modelName: 'GN125',
        registerNumber: 'GJTYJTY',
        branchOfficeName: 'Weppa',
        cost: '1000.00',
        discountedCredit: '1000.00',
        additionalCost: '0.00',
        initial: '400.00',
        initialTotal: '400.00',
        totalPayment: '820.00',
        createByName: 'Yosvani Nasco',
        extraPayment: null,
        paymentByQuotes: '600.00',
        clientId: '131',
        categoryId: null,
        hasPendingSupportRequest: false,
        rentabilityId: '2',
        createdAt: '25/03/2026',
        productTypeId: '6',
        productTypeName: 'Motor',
        reinstallPending: false,
        isFraud: false,
        hasLateQuote: false,
        supplierCode: 'AUT',
        isFromNuovoToEquality: true,
        statusCredit: 'Paid',
        unpayCredit: false,
        isCollectionAgency: false,
        collectionAgencyName: null,
        weppaPlus: false
      },
      {
        creditId: '426408',
        brandName: 'MOTOROLA',
        modelId: '2146',
        modelName: 'MOTO G34',
        registerNumber: '9195884',
        branchOfficeName: 'Weppa',
        cost: '240.00',
        discountedCredit: '180.00',
        additionalCost: '0.00',
        initial: '72.00',
        initialTotal: '72.00',
        totalPayment: '234.00',
        createByName: 'Leandro Carmenaty Pupo',
        extraPayment: null,
        paymentByQuotes: '168.00',
        clientId: '131',
        categoryId: null,
        hasPendingSupportRequest: false,
        rentabilityId: '1',
        createdAt: '02/03/2026',
        productTypeId: '1',
        productTypeName: 'Teléfono',
        reinstallPending: false,
        isFraud: false,
        hasLateQuote: false,
        supplierCode: 'EQU',
        isFromNuovoToEquality: true,
        statusCredit: 'Paid',
        unpayCredit: false,
        isCollectionAgency: false,
        collectionAgencyName: null,
        weppaPlus: false
      },
      {
        creditId: '4',
        brandName: 'Suzuki',
        modelId: '2197',
        modelName: 'GN125',
        registerNumber: 'FDHDH6575',
        branchOfficeName: 'Weppa',
        cost: '1000',
        discountedCredit: '1000',
        additionalCost: '0.00',
        initial: '400.00',
        initialTotal: '400.00',
        totalPayment: '900.00',
        createByName: 'N/A',
        extraPayment: '',
        paymentByQuotes: '600.00',
        clientId: '131',
        categoryId: null,
        hasPendingSupportRequest: false,
        rentabilityId: '7',
        createdAt: '07/04/2026',
        productTypeId: '6',
        productTypeName: 'Motor',
        reinstallPending: false,
        isFraud: false,
        hasLateQuote: false,
        supplierCode: 'AUT',
        isFromNuovoToEquality: false,
        unpayCredit: true,
        statusCredit: 'Unpay',
        isCollectionAgency: false,
        collectionAgencyName: null,
        weppaPlus: false
      },
      {
        creditId: '3',
        brandName: 'Suzuki',
        modelId: '2197',
        modelName: 'GN125',
        registerNumber: 'FDA02800',
        branchOfficeName: 'Weppa',
        cost: '1000',
        discountedCredit: '1000',
        additionalCost: '700.00',
        initial: '120.00',
        initialTotal: '870.00',
        totalPayment: '184.00',
        createByName: 'N/A',
        extraPayment: '50',
        paymentByQuotes: '130.00',
        clientId: '131',
        categoryId: null,
        hasPendingSupportRequest: false,
        rentabilityId: '4',
        createdAt: '06/04/2026',
        productTypeId: '6',
        productTypeName: 'Motor',
        reinstallPending: false,
        isFraud: false,
        hasLateQuote: false,
        supplierCode: 'AUT',
        isFromNuovoToEquality: false,
        unpayCredit: true,
        statusCredit: 'Unpay',
        isCollectionAgency: false,
        collectionAgencyName: null,
        weppaPlus: false
      },
      ...refinanceScenarioCredits
    ],
    total: [],
    status: true,
    pagination: {
      next: false,
      prev: false,
      start: 1,
      end: 5 + refinanceScenarioCredits.length,
      range: [1],
      count: 5 + refinanceScenarioCredits.length,
      pages: 1,
      total: 5 + refinanceScenarioCredits.length,
      limit: 20
    }
  }
}

export const articleDetail: { data: ArticleDetailDTO } = {
  data: {
    brandId: '1',
    brandName: 'SOPORTE 2',
    modelId: '102',
    modelName: 'Honor',
    registerNumber: '778566311',
    branchOfficeName: 'Plaza Central Este',
    cost: '200.00',
    imei: '355767752027958',
    additionalCost: '0.00',
    initial: '80.00',
    discountedCredit: '200.00',
    initialTotal: '80.00',
    totalPayment: '196.00',
    createByName: 'Nestor Test',
    extraPayment: null,
    paymentByQuotes: '140.00',
    rate: '29.38',
    createdAt: '25/07/2025',
    id: '1',
    rentabilityId: '1',
    debtWhenAssigned: '50',
    creditBeforeAssign: '1000',
    promotionDiscountPercentage: '0',
    isPromotionCreditLimit: false,
    maxCost: '547'
  }
}

export const articleTypesPage1 = {
  message: 'OK',
  data: [
    {
      id: '3',
      label: 'Apple'
    },
    {
      id: '2',
      label: 'Laptops'
    },
    {
      id: '4',
      label: 'Otros'
    },
    {
      id: '1',
      label: 'Tel\u00e9fonos'
    },
    {
      id: '6',
      label: 'Motor'
    }
  ]
}

export const categoriesPage1 = {
  message: 'OK',
  data: [
    {
      id: '3',
      name: 'Belleza y Salud',
      description: 'Productos de cuidado personal y bienestar',
      rentabilityId: '6',
      quotes: '4',
      exchange: '1',
      timesQuotes: '14',
      isActive: true
    },
    {
      id: '1',
      name: 'Computaci\u00f3n y Accesorios',
      description:
        'Equipos de c\u00f3mputo y perif\u00e9ricos para uso personal y profesional',
      rentabilityId: '1',
      quotes: '4',
      exchange: '1',
      timesQuotes: '14',
      isActive: true
    },
    {
      id: '4',
      name: 'Electrodom\u00e9sticos',
      description: 'Aparatos y dispositivos para el hogar',
      rentabilityId: '5',
      quotes: '4',
      exchange: '1',
      timesQuotes: '14',
      isActive: true
    },
    {
      id: '8',
      name: 'Electr\u00f3nicos',
      description: 'Dispositivos y gadgets electr\u00f3nicos diversos',
      rentabilityId: '2',
      quotes: '4',
      exchange: '1',
      timesQuotes: '14',
      isActive: true
    },
    {
      id: '5',
      name: 'Hogar y Muebles',
      description: 'Mobiliario y art\u00edculos decorativos para el hogar',
      rentabilityId: '4',
      quotes: '4',
      exchange: '1',
      timesQuotes: '14',
      isActive: true
    },
    {
      id: '6',
      name: 'Juguetes y juegos',
      description:
        'Art\u00edculos recreativos para ni\u00f1os y juegos de mesa',
      rentabilityId: '3',
      quotes: '4',
      exchange: '1',
      timesQuotes: '14',
      isActive: true
    },
    {
      id: '10',
      name: 'OTROS',
      description: 'Otros',
      rentabilityId: '6',
      quotes: '4',
      exchange: '1',
      timesQuotes: '14',
      isActive: true
    },
    {
      id: '7',
      name: 'Ropa y Moda',
      description: 'Vestimenta y accesorios de moda para todas las edades',
      rentabilityId: '5',
      quotes: '4',
      exchange: '1',
      timesQuotes: '14',
      isActive: true
    },
    {
      id: '9',
      name: 'TV',
      description:
        'Televisores y accesorios relacionados con el entretenimiento visual',
      rentabilityId: '4',
      quotes: '4',
      exchange: '1',
      timesQuotes: '14',
      isActive: true
    },
    {
      id: '2',
      name: 'Videojuegos',
      description:
        'Consolas de videojuegos y t\u00edtulos de juegos digitales y f\u00edsicos',
      rentabilityId: '2',
      quotes: '4',
      exchange: '1',
      timesQuotes: '14',
      isActive: true
    }
  ]
}

export const rentabilitiesActive = {
  message: 'OK',
  data: [
    {
      id: '1',
      quotes: '4',
      exchange: '1.25',
      timesQuotes: '14',
      isMain: false,
      type: ['PRODUCT']
    },
    {
      id: '2',
      quotes: '5',
      exchange: '1.25',
      timesQuotes: '14',
      isMain: false,
      type: ['PRODUCT']
    },
    {
      id: '3',
      quotes: '6',
      exchange: '1.25',
      timesQuotes: '15',
      isMain: false,
      type: ['PRODUCT']
    },
    {
      id: '7',
      quotes: '7',
      exchange: '1.25',
      timesQuotes: '15',
      isMain: false,
      type: ['PRODUCT']
    },
    {
      id: '4',
      quotes: '8',
      exchange: '1.49',
      timesQuotes: '14',
      isMain: false,
      type: ['PRODUCT']
    },
    {
      id: '5',
      quotes: '10',
      exchange: '1.25',
      timesQuotes: '14',
      isMain: false,
      type: ['PRODUCT']
    },
    {
      id: '6',
      quotes: '12',
      exchange: '2',
      timesQuotes: '14',
      isMain: false,
      type: ['PRODUCT']
    }
  ]
}

export const rentabilitiesActiveMoto = {
  message: 'OK',
  data: [
    {
      id: '10',
      quotes: '4',
      exchange: '1.30',
      timesQuotes: '14',
      isMain: false,
      type: ['MOTO']
    },
    {
      id: '11',
      quotes: '6',
      exchange: '1.35',
      timesQuotes: '14',
      isMain: false,
      type: ['MOTO']
    },
    {
      id: '12',
      quotes: '9',
      exchange: '1.42',
      timesQuotes: '15',
      isMain: false,
      type: ['MOTO']
    },
    {
      id: '13',
      quotes: '12',
      exchange: '1.55',
      timesQuotes: '14',
      isMain: false,
      type: ['MOTO']
    }
  ]
}

export const rentabilitiesPage1: { data: RentabilityResponse } = {
  data: {
    results: [
      {
        id: '1',
        quotes: '6',
        exchange: '1.39',
        timesQuotes: '15',
        isMain: false,
        type: ['PRODUCT']
      },
      {
        id: '2',
        quotes: '5',
        exchange: '1.36',
        timesQuotes: '14',
        isMain: false,
        type: ['PRODUCT']
      },
      {
        id: '3',
        quotes: '4',
        exchange: '1.30',
        timesQuotes: '14',
        isMain: false,
        type: ['PRODUCT']
      },
      {
        id: '4',
        quotes: '8',
        exchange: '1.40',
        timesQuotes: '14',
        isMain: false,
        type: ['PRODUCT']
      },
      {
        id: '6',
        quotes: '10',
        exchange: '1.45',
        timesQuotes: '14',
        isMain: false,
        type: ['PRODUCT']
      },
      {
        id: '7',
        quotes: '12',
        exchange: '1.50',
        timesQuotes: '14',
        isMain: false,
        type: ['PRODUCT']
      },
      {
        id: '76',
        quotes: '3',
        exchange: '1.00',
        timesQuotes: '15',
        isMain: false,
        type: ['PRODUCT']
      },
      {
        id: '107',
        quotes: '10',
        exchange: '1.10',
        timesQuotes: '10',
        isMain: false,
        type: ['PRODUCT']
      }
    ],
    total: [],
    status: true,
    pagination: {
      next: false,
      prev: false,
      start: 1,
      end: 8,
      range: [1],
      count: 8,
      pages: 1,
      total: 8,
      limit: 50
    }
  }
}

export const rentabilitiesPage1Moto: { data: RentabilityResponse } = {
  data: {
    status: false,
    pagination: {
      next: false,
      prev: false,
      start: 1,
      end: 4,
      range: [1],
      count: 4,
      pages: 1,
      total: 4,
      limit: 50
    },
    results: [
      {
        id: '10',
        quotes: '4',
        exchange: '1.30',
        timesQuotes: '14',
        isMain: false,
        type: ['MOTO']
      },
      {
        id: '11',
        quotes: '6',
        exchange: '1.35',
        timesQuotes: '14',
        isMain: false,
        type: ['MOTO']
      },
      {
        id: '12',
        quotes: '9',
        exchange: '1.42',
        timesQuotes: '15',
        isMain: false,
        type: ['MOTO']
      },
      {
        id: '13',
        quotes: '12',
        exchange: '1.55',
        timesQuotes: '14',
        isMain: false,
        type: ['MOTO']
      }
    ]
  }
}

export const insuranceRentabilityPage1: {
  data: InsuranceRentabilityOptionResponseSchema
} = {
  data: [
    {
      id: '35',
      month: '1',
      percentage: '0',
      isActive: true,
      name: null,
      type: 'ASIGNAR'
    },
    {
      id: '45',
      month: '2',
      percentage: '0',
      isActive: true,
      name: null,
      type: 'ASIGNAR'
    },
    {
      id: '45',
      month: '3',
      percentage: '0',
      isActive: true,
      name: null,
      type: 'ASIGNAR'
    },
    {
      id: '36',
      month: '2',
      percentage: '1',
      isActive: true,
      name: null,
      type: 'ASIGNAR'
    },
    {
      id: '2',
      month: '4',
      percentage: '45',
      isActive: true,
      name: null,
      type: 'ASIGNAR'
    },
    {
      id: '38',
      month: '5',
      percentage: '4.8',
      isActive: true,
      name: null,
      type: 'ASIGNAR'
    },
    {
      id: '1',
      month: '6',
      percentage: '5',
      isActive: true,
      name: 'Mi rentabilidad bonita',
      type: 'ASIGNAR'
    }
  ]
}

export const segurosMercantil = {
  message: 'OK',
  data: [{ id: '1', label: 'Seguros Mercantil' }],
  status: 200
}

export const articleCuotesPage1: {
  data: QuoteListResponse
  message: string
} = {
  message: 'OK',
  data: [
    {
      quoteId: '1',
      creditId: '1',
      paymentDate: '30/12/1899',
      dueAt: '01/08/2025',
      quote: '25',
      status: 'PAGADA',
      paid: '25'
    },
    {
      quoteId: '2',
      creditId: '1',
      paymentDate: '30/12/1899',
      dueAt: '15/08/2025',
      quote: '50',
      status: 'PENDIENTE',
      paid: '25'
    },
    {
      quoteId: '3',
      creditId: '1',
      paymentDate: '30/12/1899',
      dueAt: '22/08/2025',
      quote: '60',
      status: 'ATRASADA',
      paid: '25'
    },
    {
      quoteId: '4',
      creditId: '1',
      paymentDate: '30/12/1899',
      dueAt: '01/08/2025',
      quote: '25',
      status: 'PAGADA',
      paid: '25'
    },
    {
      quoteId: '5',
      creditId: '1',
      paymentDate: '30/12/1899',
      dueAt: '15/08/2025',
      quote: '50',
      status: 'PENDIENTE',
      paid: '25'
    },
    {
      quoteId: '6',
      creditId: '1',
      paymentDate: '30/12/1899',
      dueAt: '22/08/2025',
      quote: '60',
      status: 'ATRASADA',
      paid: '25'
    },
    {
      quoteId: '7',
      creditId: '1',
      paymentDate: '30/12/1899',
      dueAt: '01/08/2025',
      quote: '25',
      status: 'PAGADA',
      paid: '25'
    },
    {
      quoteId: '8',
      creditId: '1',
      paymentDate: '30/12/1899',
      dueAt: '15/08/2025',
      quote: '50',
      status: 'PENDIENTE',
      paid: '25'
    },
    {
      quoteId: '9',
      creditId: '1',
      paymentDate: '30/12/1899',
      dueAt: '22/08/2025',
      quote: '60',
      status: 'ATRASADA',
      paid: '25'
    },
    {
      quoteId: '10',
      creditId: '1',
      paymentDate: '30/12/1899',
      dueAt: '01/08/2025',
      quote: '25',
      status: 'PAGADA',
      paid: '25'
    },
    {
      quoteId: '11',
      creditId: '1',
      paymentDate: '30/12/1899',
      dueAt: '15/08/2025',
      quote: '50',
      status: 'PENDIENTE',
      paid: '25'
    },
    {
      quoteId: '12',
      creditId: '1',
      paymentDate: '30/12/1899',
      dueAt: '22/08/2025',
      quote: '60',
      status: 'ATRASADA',
      paid: '25'
    }
  ]
}

export const creditByRegisterNumber: { data: AssignArticle } = {
  data: {
    productId: '1',
    creditId: '132132',
    imei: '4324',
    registerNumber: '12345',
    brandId: 1,
    brandName: 'LG',
    modelId: 1,
    modelName: 'Modelo ByRegisteNumber',
    productType: 1,
    promotion: {
      id: 1,
      name: 'locura azul',
      startDate: '',
      endDate: '',
      initialPercentage: '0.4',
      noCreditLimits: false,
      insuranceRentabilityId: '38',
      insurancePercent: '5.00',
      minCost: '100.00',
      maxCost: '1000.00',
      rentability: {
        rentabilityId: '5',
        quotes: '5',
        exchange: '1.5',
        timesQuotes: '12',
        isMain: false,
        type: ['PRODUCT']
      }
    },
    maxCost: '547'
  }
}

// Phone without promotion, used to test the legacy (non-preassigned) assign flow
export const creditPhoneWithoutPromotionByRegisterNumber: {
  data: AssignArticle
} = {
  data: {
    ...creditByRegisterNumber.data,
    imei: 'FAST-IMEI-01',
    registerNumber: 'FAST01',
    brandName: 'Samsung',
    modelName: 'Galaxy FAST',
    promotion: null
  }
}

export const creditLaptopWithPromotionByRegisterNumber: {
  data: AssignArticle
} = {
  data: {
    ...creditByRegisterNumber.data,
    imei: 'LAPTOP-IMEI-01',
    registerNumber: 'LAPTOP01',
    brandName: 'Lenovo',
    modelName: 'ThinkPad',
    productType: 2,
    promotion: {
      ...creditByRegisterNumber.data.promotion!,
      id: 444,
      name: 'Promo Laptop con Weppa Plus',
      rentability: {
        ...creditByRegisterNumber.data.promotion!.rentability,
        rentabilityId: '2',
        quotes: '5'
      }
    },
    maxCost: '900'
  }
}

export const creditPhoneWithPromotionByRegisterNumber: { data: AssignArticle } =
  {
    data: {
      ...creditByRegisterNumber.data,
      imei: '353341834953998',
      registerNumber: 'PROMO01',
      brandName: 'ASUS',
      modelName: 'ASUS ZENFONE 11',
      promotion: {
        ...creditByRegisterNumber.data.promotion!,
        id: 333,
        name: 'Promo Phone 25%',
        initialPercentage: '25.00'
      },
      maxCost: '1200'
    }
  }

export const creditByRegisterNumberOthers: { data: AssignArticle } = {
  data: {
    productId: '1',
    creditId: '132132',
    imei: '4324',
    registerNumber: '12345',
    brandId: 1,
    brandName: 'LG',
    modelId: 1,
    modelName: 'Modelo ByRegisterNumberOthers',
    productType: 4,
    promotion: {
      id: 1,
      name: 'locura azul',
      startDate: '',
      endDate: '',
      initialPercentage: '0.4',
      noCreditLimits: false,
      rentability: {
        rentabilityId: '5',
        quotes: '5',
        exchange: '1.5',
        timesQuotes: '12',
        isMain: false,
        type: ['PRODUCT']
      }
    },
    maxCost: '547'
  }
}

export const creditAppleByRegisterNumber: { data: AssignArticleApple } = {
  data: {
    id: '2',
    orderNumber: 'SO-USMP-0424',
    imei: '353341834953730',
    storage: '128GB',
    status: 'DESBLOQUEADO',
    registerNumber: 'C2CQ3MKCQ0',
    brandId: 54,
    brandName: 'APPLE',
    modelId: 592,
    modelName: 'APPLE 13',
    maxCost: '732.20',
    promotion: {
      id: 331,
      name: 'Promo Apple 15%',
      startDate: '01/09/2026',
      endDate: '31/12/2026',
      initialPercentage: '15.00',
      noCreditLimits: false,
      rentability: {
        rentabilityId: '7',
        quotes: '12',
        exchange: '1.50',
        timesQuotes: '14',
        isMain: false,
        type: ['PRODUCT']
      }
    }
  }
}

export const creditAppleWithPromotionByRegisterNumber: {
  data: AssignArticleApple
} = {
  data: {
    ...creditAppleByRegisterNumber.data,
    id: '3',
    orderNumber: 'SO-USMP-0425',
    imei: '353341834953999',
    registerNumber: 'PROMO01',
    modelName: 'APPLE 15 PRO',
    storage: '256GB',
    maxCost: '1200.00',
    promotion: {
      id: 332,
      name: 'Promo Apple 25%',
      startDate: '01/09/2026',
      endDate: '31/12/2026',
      initialPercentage: '25.00',
      noCreditLimits: false,
      rentability: {
        rentabilityId: '7',
        quotes: '12',
        exchange: '1.50',
        timesQuotes: '14',
        isMain: false,
        type: ['PRODUCT']
      }
    }
  }
}

export const creditByBodySerial: { data: AssignedArticleMotorListResponse } = {
  data: {
    id: '266',
    imei: '98765',
    status: 'DESBLOQUEADO',
    modelYear: 1900,
    assembler: 'Ensambladora Test',
    color: 'GRIS',
    bodySerial: '98765',
    registerNumber: 'ABC123',
    originCertificateNumber: '54321',
    productType: 6,
    engineSerial: '76543',
    chassisSerial: '98765',
    vehicleClass: 'MOTOCICLETA',
    originCertificateDate: '2026-06-08T00:00:00-04:00',
    brandId: 207,
    brandName: 'Suzuki',
    modelId: 2197,
    modelName: 'GN125',
    maxCost: '547',
    promotion: {
      id: 331,
      name: 'Test-oro',
      startDate: '02/06/2026',
      endDate: '13/06/2026',
      initialPercentage: '20.25',
      noCreditLimits: true,
      rentability: {
        rentabilityId: '7',
        quotes: '12',
        exchange: '1.50',
        timesQuotes: '14',
        isMain: false,
        type: ['PRODUCT']
      }
    },
    creditId: '',
    productId: '',
    vin: '',
    automotiveModel: {
      loadCapacityKg: '200',
      axleCount: 4,
      seatingCapacity: 3,
      tareWeightKg: '440'
    }
  }
}

export const editArticleRequestCuotesPage1: {
  data: EditArticleRequestQuoteListResponse
  message: string
} = {
  message: 'OK',
  data: {
    quotes: [
      {
        quoteId: '1',
        dueAt: '02/08/2025',
        quote: '26'
      },
      {
        quoteId: '2',
        dueAt: '16/08/2025',
        quote: '51'
      },
      {
        quoteId: '3',
        dueAt: '23/08/2025',
        quote: '61'
      }
    ]
  }
}

export const devicesInfo: { data: NuovoDevice } = {
  data: {
    id: 6970692,
    name: null,
    imei_no: '',
    imei_no2: null,
    serial_no: 'd326453b7d86',
    phone_number: null,
    model: '24075RP89G',
    is_tv: false,
    make: 'Xiaomi',
    os_version: '14',
    sdk_version: '34',
    status: 'enrolled',
    device_group_id: null,
    lock_type: 'unlocked',
    admin_lock_type: 'admin_unlocked',
    app_version_code: 419,
    app_version_name: '8.5.4-IC',
    created_at: '29-04-25 16:55:08 UTC',
    is_activated: true,
    locked: false,
    admin_locked: false,
    is_locked_on_sim_swap: false,
    first_lock_date: null,
    first_lock_date_in_iso_format: null,
    next_lock_date: '18/10/2025',
    next_lock_date_in_iso_format: '18/10/2025T04:00:00',
    customer_name: null,
    customer_email: null,
    customer_address: null,
    customer_phone_number: null,
    unlock_code: '65893100404',
    validity_of_unlock_code: 3360000,
    custom_fields: [],
    eula_status: 'Accepted',
    eula_action_performed_on: '26-09-25 17:50:17 UTC',
    sim_lock_info: {
      approved: [],
      unapproved: [],
      auto_approve_new_sim: { state: null, expiry_time: null }
    },
    device_setting_attributes: {
      lock_on_sim_swap: 'use_global_setting',
      disable_unknown_sources: null,
      mandatory_packages: null,
      auto_lock_schedule: { scheduler_id: null, name: null }
    },
    nuovoclub_details: {
      nuovoclub_enabled: true,
      is_password_set: false,
      nuovoclub_language: null,
      nuovoclub_users: []
    },
    last_connected_at: '14-10-25 14:45:09 UTC',
    getting_started_button_clicked: true,
    enrollment_status: 'Completed',
    enrollment_failure_reason: null,
    additional_setup_done: true,
    battery_optimization_granted: 'Yes',
    enrolled_on: '26-09-25 17:49:55 UTC',
    supports_sms_lock_feature: true,
    dlc_details: { dlc_status: 'Not available' },
    renewal_status: 'na',
    reset_password_details: {
      password_set_on_device: false,
      support_reset_password: true,
      pasword_reset_status: 'NA',
      password_reset_code: 'NA'
    },
    device_firmware: '',
    device_type: {
      id: 1,
      name: 'Teléfono'
    }
  }
}

export const equalityDevicesInfo: { data: EqualityDeviceInfoResponse } = {
  data: {
    modelId: '2',
    modelName: 'Redmi Note 9',
    stateInfo: 'active',
    promotion: null,
    maxCost: '547'
  }
}

export const mundoDevicesInfo: { data: MundoDeviceResponse } = {
  data: {
    statusId: 3,
    statusName: 'DESBLOQUEADO'
  }
}

export const modelsNuovo = {
  data: {
    brandName: 'Xiaomi',
    brandId: '12',
    name: 'Redmi 9',
    id: '7'
  }
}

export const enrolledHours: { data: EnrolledHoursResponse } = {
  data: {
    hours: 48,
    enrolledMoreThan48h: true,
    isVerifiedInNuovo: true
  }
}

// Apple scenarios (by register number) to exercise promotion vs applePercent
const appleNoPromotion = {
  ...creditAppleByRegisterNumber.data,
  promotion: null
}

export const creditAppleScenariosByRegisterNumber: Record<
  string,
  { data: AssignArticleApple }
> = {
  // Enrolled > 30 days: no promotion, applePercent applies
  ENROLL01: {
    data: {
      ...appleNoPromotion,
      id: '4',
      registerNumber: 'ENROLL01',
      applePercent: 20
    }
  },
  // Backend error: promotion AND applePercent sent -> applePercent must win
  BOTH01: {
    data: {
      ...creditAppleWithPromotionByRegisterNumber.data,
      id: '5',
      registerNumber: 'BOTH01',
      applePercent: 20
    }
  },
  // Not enrolled, no promotion, no applePercent
  PLAIN01: {
    data: {
      ...appleNoPromotion,
      id: '6',
      registerNumber: 'PLAIN01'
    }
  }
}

export const enrolledMoreThan30DaysBySerial: Record<string, boolean> = {
  ENROLL01: true,
  BOTH01: true
}

export const mosyleDeviceLookup: { data: MosyleDeviceLookupResponse } = {
  data: {
    isEnrolledMoreThan30Days: true
  }
}

export const supplier: { data: Supplier } = {
  data: {
    id: '2',
    name: 'Apple',
    code: 'APL',
    productTypeId: '3',
    productTypeName: 'Apple'
  }
}

export const supplierNuovoLaptop: { data: Supplier } = {
  data: {
    id: '1',
    name: 'Nuovo',
    code: 'NVO',
    productTypeId: '2',
    productTypeName: 'Laptop'
  }
}

export const supplierApple: { data: Supplier } = {
  data: {
    productTypeId: '2',
    productTypeName: 'Laptop',
    id: '2',
    name: 'Apple',
    code: 'APL'
  }
}

export const supplierMundo: { data: Supplier } = {
  data: {
    id: '3',
    name: 'Mundo',
    code: 'MUN',
    productTypeId: '1',
    productTypeName: 'Teléfono'
  }
}

export const supplierAutomotive: { data: Supplier } = {
  data: {
    id: '3',
    name: 'Automotriz',
    code: 'AUT',
    productTypeId: '6',
    productTypeName: 'Motor'
  }
}

export const QRImageData: { data: QRImageDataApiValidationResponse } = {
  data: {
    enrollment_code: 'C86D47',
    qr_standard:
      'data:image/png;base64,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',
    qr_huawei:
      'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAaQAAAGkAQMAAABEgsN2AAAABlBMVEUEAgT8/vxJvsdeAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAQUUlEQVR4nO2cva3ryNJFW6BBT0yAANOgx5SkBPSTgJQSPaZBgAmIHg1C/dYq6s5YH/DhGT3Gm4OLA11JWzhNVe/au6qaKf8XP5/0L+p/AjWm09ae6/walmeunlP3qfnd3vrlPaVzvTdbOqf8Tfsl7actXVK6F0ZNec3817flab/mudn2Wz1f6vnWdy+ezOk8dM+pylt7zema9+KodOVt/ZzqdOMvn9KlTqmf7y4wv/rqO8yXfr/U3SMtr2G/ju0/gXIJj2F5JLD7Pbf3nB99ug37aeS/VR67dWv5tHPfrf8Iamqv05LHlqU1OflTt7ehjQfpxKUeeTDz7aS+vf4DKGKj+w750+/3qeL3jaWNXHCW1vIMVzslHsynMV36av07okqh2F+u6//77+9dWQzFzzR7SQmJqcsjgUrozk1uudT3KTVT9615sDdT4vf9L2Yrh6o+qVo3v/1U85g95eNm696bwRyBzTP7KcMSbMDiKL99gxaO+vRQU36PchE76zxUvP+cqve4rFzzYVkN4+Ko3D3zngZ22UFH87lnT7HAmU33zkQs1EoK4LLzHZEOqtKobXml/brlx5Cf4/Lc8pdPGBNX/tHvzWjAvKf2zoOx+/TLmoMBSqKmXRrv2ThcWP5kX32PxsZjqN4bRFo9uNobeWo+5bxOe2nUxh+f33l5DLOpcFq+pMiUXcvUNlz8aXnVpPt0zwQPH7Lkwih5XkXxqjsjOVXPbSdXNi6ky1smcvi0hBqZiJZsWi+OusNF2/KoCdEcAmN5jyiQnfe883we2lNmsTyD6uDBoYgKonh1hARMgnDpzWvuVnr1sCiL6j6DSfyZZ4LnUy/rlnNhFJfXfU1k7mjIC3k8kZuqb5/fQaSKSeKBuN2SJL8d+6sgKrdX1M7QRRgvQaEu7Vbn56ZGumcSExsNWmjPiQwV0VsSNeYXCZpnBiR696i54Mu3JlQgf5ZMGAOHWtvTqD5PdXEU68pq8tTDP/mReG5vVJWoC1QQv6tXb0I/D7vCOBdHSUGkG0KXlwyGm4kbFGKY68/3Yhr9Jmh2VxGhRgqjtuopvXfPkdTjJ9wg/G0/m54WsIREg8jEgtXoz9avozBqwmSx35FtSZ4fWQtJnIzpdYbbH/IqaRQ9bITftyN/FUSN+aG3mhuMzAaRYiIIhniMFK+lJsN763LWo10OFi2J4md0N11HLZicSdIZDZIG9x382fDtSFDGz2PYS6O26kOm5sLqT2dyIrq3iVWctvkez2S5lE8j3RPGR3YoiELhKNWMkBXjgBHj1ck9xfVPxgwGtvumdEl4Rvi/Ko3Surrf4fPk8+yp+J34KEzs4gK55maoDn2e6q40ynV1JJ335HU+TZ1mlrhNfCP6L568DLxExuQx/6rSKHheD2gAKN60//DS3hAPUOiIiViUbSP+ml3GS11p1Di7CnK3fzMCsr1o/2dLAUR1rCv5QBPEV8B77oVRm987Uuflitj4RAUpG3WEHdt5Rqk5AIQl5Hx8bi6McivxnvZmomybje1/+P3dLb/B9tA7kcMGZF14sVwalS2EYrRJkW98wQiR7ue+MjNOADHd+kcgYXz+eIeSqK3ScCG5WaCiYnkN+WtBjwxu/YR1wZy47NAhqRl/eqMcynqUVPm22KgR+/TwAMlIZY7Z+QzhEJN78DVUn6EtjtrZTejw7B4Ph1WbLsFetbEErdUVthuuNg04iL00alPcnkk6Q/XoK4SHpZ5Jl30brJslq+L8a0+T9HXpD6VXFHVD59RAyDu4A17imhOofELFq6z6MrjXmlzpLH4RVRCVVREEBqT0qhXnj6F6KYP5CkhGvh/zeFMy8V1w/Y/sUBIFSdpqISEiLEmRZHYenPFfU/UY2mgu5GPvQ2JYiXtpVEpD0FRtmwCm+g7LW81G3JrZT1zwgTUS3tbQTtvBbAVR7nT+ZqIC1QEdVbwfLdRot02dlqQ2nCN7v3Nz/XptJVEEQPUJl5qg96RpfUfQkowS9I656Fm4qdwGx7aURpllcKZEBalH9atQ18PC7RW++7kFFUzoYVKSwXwvjDJivciN1ATKVgKsZd9K36pDXEfiefkYHqGRCqO2bJ02h7+29+d/zyYdje1pEkLErqxUjeTCc2EU2yfJURiH02YJ96tf4AqzlUjx+DK2HsGsiWhy/lUdy6JeyMWM0WaLLQ+yYdZlQ1OKzMkCmv3KqNi/8EFHbBRF5cjXNgFdGj4iWVh+jwRGR8TyvCS/6dHgq/dYHGWJu7LbkpC41sCRHJ8hWW2WtfwWrln/dbXGm675T+W2GMqGGnyO2tFEnAiAkbQe7YzRgCFIrlZRpIhPPetqC6Oi1v228JiO/guGK9xWOkwrbhHZqZuQWu0Cl0bJ3naFLNHb7MA1yOck8VsCwur4KLszxEaKLFAaFf2g1OvCtPk4GrvkiEwHOe7j8sJZDBafE4bRysBR1S+I0sN2iLR188++2DjYFZajZR9rAmYl369hhBaOjmpJFH5fC6PPivYQ7+f6w6LLynscg/EN71ESezqLshRHJfu8AyTPLrNCCx1B5mc9LM/Yfcs+SU7fozH9c4jlUO6vJW8wOXJIB3FR8fr7nm2UR31+tiBJzPDJQ1saRQ4ya1sre5IorZ8AsWaLmAxa0EHc+m7F6spjc2kUOzp3dl42rDS6wspt6nlsdeWrtUH3Rhdp6rSQR5+oJMrSt8uBjohSsvk35OUD4GCRJxpGwA0hln9LVWmUqUdNe4+pNi0YodtnPY5K0tLZ6mzMfLXna4nvXhpFxsFHox5VHXe7Bk4JNjIVy4RUHed42D+qorx2qMqSKKcTr068oDGwOTYE+UEXsbps54hVL5ZcLKfY4i+N0h46VvetWZ0lR32W3E7AWOLD4MBLWLPVpK9HK47iaqN1F7C2p2sb0/hWyPOVWON8cjqrekoUrveVDtdWEBWFUAyXNE7Q1n6IA05seecNEB45eADmV1ueh9+uLIciIJ2bteFitXaL+IwWKtncjwpL+zXjH1SwFEdxbZcn9sohE/I4fL7YAs7+JrYdmnWeln3XXtJ864/8VRBlydHGtHvHzmlqMrssqrVDe/aLcMgEFCYRD/vO5VEQeND4QNBm0vrHeVT+WbI4H1Vc2WC+KjWRJXtp1LY3OQpNUJA80Dlm7PRLF8VkOZYcinKLWm4wWGGUMxvdoz4S5X6OFuoD2ZN5cxuEX61bJKOQlK+hK47q3PXWb3lpjkwEU+WXJOBo1tOJWUPanubmuPK9MCrHgLGVRp3C5ZiFtvOLBraz9s72s/AXq7Vl3nPUlguiHOJ1RdcxjOrYWc8ZIXl7H1qzyOm8dDUrhUcrjgrHahq6Hmm9Dv1WdzYopyDY/hjEkvmvv75DQVT2b7YpaTOI648MPiYq4QRsBR+VH1pX6y23/q++eUGUIaG1iaMEUhCy3MYuXKqtRuiy5GNG2rmdlMqjyJUz4jaP2FUetw44mcr1jA9TeSxZM27kPH6zWAVRo6MaKLSn9ds2DrOQxC1WONkLsdvi13/hce4Zy1McZRgoF0+TI6mpzryqFMd6J2vdyeGc7gujjkr012/CpCDKoURn1d421/YmBuPPREXvJOrHQi7E5fgQdOoXlH99h3Ko0cHyC+93Sod/e7gb+7y4WmSGStKBIkR7m2IQpTQqem3ZRGNUODY5av8bB7EcTnae1rlu2wfftJPQc3HU2dztLMTN8rt8tWanFu9OOlUGz8jHhuVx1O23rpKoi8cc4tVcva1KtdbuvNpdHCeBPy082rP2wMuRYQui0Gy4rSFKsp7BsV+AeuQKP+PAC+Rga9Wpg2jEbL8585Io5/2cDYsGgUUn/nA05OIU1uZBErIShI8Afg2w2c/DlkNZPbaEck4Oea6O6ztzEkQqLSDq1m22XW7VFFtx9BALovIxT76sSFz4RxemEg52agmbW0wM3qQvUlKk+9KoNv5gS7KeqCJl99b3rhv5HdsVaTTmzE3oo6Oq98KoibBUC30Gy48vF1o90Zk52Ak7455yKItnbs4UpdIoD93gpvmN31f/XIYQPwTM1CHOebKZ4snNouif6aOCKPtEyWZuitpsnKfju3CCaHC+yIENS1IxIjgoloqjDAAstkdKHfGdPQ87eaDAxsFo89cy2mRJ6lX/mUAuido8SoDDajwV4pBYci5C7/DUfQd2yp/aXrCtmeO8Q1EUEsiM80H9HofUnLxC6JLZ+SLiJE6/eJRSDYwo6kqjrJXlT8wEIni+BK2uVh64mB/nGAHdY0pfHZLKoywa73cPrccg9HR0eJGUWkLP49Q2Dpyjdvyg/fmvsijy+CM2/nWyKcmbzZh1DOePrvSuB6/izItT06VRHgx3Ym21Le66blqGylMYbrSsME7HA9sKFgcKo7ZwrFvcFgCSzDGUVeu81Oqx5cPMQlB8YPtnYqEgKiM2orroO0M9Ogfo1HSj9ui+fdSZkwNjaKdrLo5ip6u97ThjalaHYWAkDKPv/A7HmWj4qo1Itsh8L4xCjdvjg0itV7w9YmzePPPKxDJJ3+Tx1ExzyOPld3+AkijPKzmUyGX3kAgX3/OSFpztm9edg0+1M2P3o431i96CKI+HexjtaQMrNaO3IvH0jXMRspay7RhY3fhY83tp1HGPkbGLtq/zJMTzLVXHSr/eO8U6lZIYNQKDDak0ajpsS5wMspfRPaf8cq95iuSmSOMlSICsZN3+8at+l0SRKJ2B99DuWMUE4x720AFL6zyW0ZBHZE/76d9UHIXe6DEItvk892rXgBiYm7hVBe77ueU4fR+7zIbCwRsFUdPyjNMNTzd4HEazAun5C5sd1gfsGjTeSQPOn/+cvi+Iwjig0+oYhPaIn+LtYvXJG+AcPJBtpML5vOHP/EZJlKbP3v3HSXgMgif+7PWHVDtzzSc+x0OdZ0+7xBxjYZRtXBtVql+PTDoo6wnZcKwvBxora2jOYrFG1vU7RVsO5WyG9agHdOS9pJzbX81ENnx1NN4HyRMunsvQPvyZQC6GckYox7FNCN+7kRClq56rWqOlvlqBdPQ3OuzOzJdGWcxx7Gp11xMMKPD9TxcVhp9JUh+bIGEchhDwhVFxb4q3ddGj7lTFdFPn7cLimFUUxitvIBZ2LP2cb0GUstzBgxigjdk2D3W2t2i+NOPRbqs8oeYYz/xj0aIoS/H40086VJD3Xzrlo2UJo3reobEjEzeyiOZCcZRlbWtNpOuwDOm4+1Y67iOkDokzxeniCMpfs6kFUdZM7EheNFkxuYEl9CRLlJEn3uxNXez55uqYoy6NinOImNYmaiaeNHRGOtuAq0PFJcR5lH22JW469PfpxUIoq45Wck4OqRKlxIlG1Tpe3Hrr5PmguD2XIb3/zhQXRXk/PcLV2HD2gEsdN+NynOO4yZ43YfOUsTtu/utMcVGU5FkdJ3Of2eG6CBj3+zmm32/eyMXZGCuQfyaQy6IWkvUH4z/aV9V/peXTh+TwjEO62Nqwa5ljkieXRnnQJu5Upttyy9ewU9T0rKvwNs2sXdfkjRf+nGopiFJjRDEqd94BLO4wGfcEY8dZgLp4Rtv7g2WrVU6OlUb9Fz//ov5F/Z+o/wCqAKVuRhD5pgAAAABJRU5ErkJggg==',
    raw_config:
      '{"android.app.extra.PROVISIONING_DEVICE_ADMIN_COMPONENT_NAME":"com.promobitech.nuovo/com.promobitech.mobilock.component.MobilockDeviceAdmin","android.app.extra.PROVISIONING_DEVICE_ADMIN_PACKAGE_DOWNLOAD_LOCATION":"https://dl.nuovopay.com/apk/?c=ZENQTzUxM3pwNUVKbllkTm5hS3hHZz09Cg==","android.app.extra.PROVISIONING_DEVICE_ADMIN_SIGNATURE_CHECKSUM":"17A1Ac-PbE2GygkB_R8TClRPouyR0AVQnV76r1VTEqs","android.app.extra.PROVISIONING_LEAVE_ALL_SYSTEM_APPS_ENABLED":true,"android.app.extra.PROVISIONING_ADMIN_EXTRAS_BUNDLE":{"management_server":"https://api-android.nuovopay.com/o/?c=RDcxOU16Rm9GVGo2Zm1QRjExcFlYUT09Cg==","enrollment_mode":5},"auto_enroll":"true"}'
  }
}

export const otpVerify: { data: RequireOTPResponse } = {
  data: {
    createdAt: '2026-3-23 14:30:58',
    id: '12',
    hoursSinceCreation: 16,
    requireOtp: false
  }
}

export const creditUnpay: { data: CreditUnpayResponse } = {
  data: {
    id: '3',
    registerNumber: 'FDA02800',
    largeJson: {
      cost: '1100',
      rentability: '1',
      extraPayment: '30',
      dayCreditBegan: '08/04/2026',
      discountedCredit: '1100',
      client: '131',
      imei: 'V333',
      model: '2197',
      registerNumber: '8797976',
      productType: '6',
      additionalCost: '0.00',
      initial: '440.00',
      initialTotal: '470.00',
      totalPayment: '876.00',
      paymentByQuotes: '630.00',
      rate: '1.39',
      promotionDiscountPercentage: '0',
      isPromotionCreditLimit: false,
      creditBeforeAssign: '2500.00',
      profit: '246.00',
      quotes: [
        {
          quote: '146.00',
          dueAt: '23/04/2026',
          paid: 0
        },
        {
          quote: '146.00',
          dueAt: '08/05/2026',
          paid: 0
        },
        {
          quote: '146.00',
          dueAt: '23/05/2026',
          paid: 0
        },
        {
          quote: '146.00',
          dueAt: '07/06/2026',
          paid: 0
        },
        {
          quote: '146.00',
          dueAt: '22/06/2026',
          paid: 0
        },
        {
          quote: '146.00',
          dueAt: '07/07/2026',
          paid: 0
        }
      ],
      supplierId: '5',
      driverLicenseImage: '',
      idCardImage: '',
      insurancePolicyImage: '',
      insuranceProvider: '1',
      medicalCertificateBackImage: '',
      medicalCertificateFrontImage: '',
      policyNumber: '08965',
      rifImage: '',
      invoiceImage: '',
      invoiceNumber: '1345465',
      originCertificateImage: '',
      unpaidCredit: true,
      bodySerial: '12345',
      branchOfficeId: 0
    },
    clientName: 'Pepe Juanete',
    clientId: '131',
    createdAt: '06/04/2026'
  }
}

export const readOriginCertificate: { data: OriginCertificateResponse } = {
  data: {
    vehicle: {
      type: null,
      model: null,
      bodySerial: null,
      originCertificateNumber: '1111111',
      originCertificateDate: '12/12/2000',
      engineSerial: null,
      chassisSerial: null,
      seats: null,
      axes: null,
      taraKg: null,
      loadCapacityKg: null,
      vehicleClass: null,
      modelYear: null,
      vin: null,
      plateNumber: 'ZXC4546',
      brand: null,
      year: null,
      use: null,
      service: null,
      primaryColor: null,
      secondaryColor: null
    },
    certificate: {
      controlNumber: null,
      companyName: null,
      emissionDate: null,
      entryPort: null,
      invoiceNumber: '9999999',
      invoiceDate: null,
      invoice3Number: null,
      invoice3Date: null,
      taxSheetNumber: null,
      taxSheetDate: null,
      acquisitionInvoiceNumber: null,
      acquisitionDate: null,
      refeciv: null,
      agreementEndDate: null,
      buyerDocument: null,
      buyerName: null,
      buyerHouseNumber: null,
      buyerUrbanization: null,
      buyerMunicipality: null,
      buyerAddress: null,
      buyerCity: null,
      buyerPostalCode: null,
      buyerFederalEntity: null,
      insuranceCompany: null,
      insurancePolicyExpiry: null,
      reservationFavor: null,
      reservationDocument: null
    }
  }
}

export const miscellaneousCredit: { data: { id: number } } = {
  data: { id: 87 }
}

export const creditPreassignedDetail: {
  data: CreditPreassignedDetailDTO
} = {
  data: {
    id: 190,
    registerNumber: 'C2CQ3MKCQ0',
    imei: '353341834953730',
    cost: '100.00',
    additionalCost: null,
    initialCash: '17.00',
    initialWallet: '8.00',
    initialTotal: '25.00',
    totalPayment: '25.00',
    extraPaymentCash: '7.00',
    extraPaymentWallet: '18.00',
    paymentByQuotes: '76.00',
    isBiometricVerify: true,
    clientId: 731997,
    clientName: 'chicho el cojo',
    categoryId: 10,
    categoryName: 'Apple',
    productTypeId: 3,
    productTypeName: 'Apple',
    modelId: 592,
    modelName: 'APPLE 13',
    branchOfficeId: 6,
    branchOfficeName: 'Weppa',
    rentabilityId: 2,
    insuranceRentability: {
      insuranceRentabilityId: 93,
      name: 'dos',
      percentage: '2.00',
      month: '2',
      type: 'ASIGNAR'
    }
  }
}

export const miscellaneousRentability: {
  data: MiscellaneousRentabilityDTO | null
} = {
  data: {
    id: '41',
    quotes: '3',
    exchange: '1.00',
    timesQuotes: '15',
    isMain: false,
    isForMiscellaneous: true,
    initial: '10.00',
    creditLimit: '500.00',
    clientId: 147341,
    clientName: 'ALEJANDRO ANTONIO RIOS RODRIGUEZ',
    documentNumber: '26152650'
  }
}
